import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { CentralizedLags } from "./Lags";
import { CentralizedRestrictedItems } from "./RestrictedItems";

export const CentralizedLagsAndRestrictedItems = () => {
  const query = useQuery();
  const navigate = useNavigate();
  useEffect(() => {
    if (query.get("id")) {
      return;
    }

    const activeTab = query.get("activeTab");
    const subActiveTab = query.get("subActiveTab");
    if (!activeTab) {
      navigate(
        `/centralized/centralizedLagsAndRestrictedItems?activeTab=centralizedLags&subActiveTab=centralizedLagsPageContent`,
        {
          replace: true,
        }
      );
    } else {
      let defaultSubActiveTab: string | null = null;
      switch (activeTab) {
        case "centralizedLags":
          defaultSubActiveTab = "centralizedLagsPageContent";
          break;
        case "centralizedRestrictedItems":
          defaultSubActiveTab = "centralizedRestrictedItemsCheckedInCabinRestrictionsContent";
          break;
        default:
          defaultSubActiveTab = "centralizedLagsPageContent";
          break;
      }
      navigate(
        `/centralized/centralizedLagsAndRestrictedItems?activeTab=${activeTab ?? "centralizedLags"}${
          defaultSubActiveTab ? `&subActiveTab=${subActiveTab || defaultSubActiveTab}` : ""
        }`,
        { replace: true }
      );
    }
  }, [query.get("activeTab"), query.get("subActiveTab")]);

  const travellersInfoCard = [
    {
      label: "LAGs",
      key: "centralizedLags",
      children: <CentralizedLags />,
    },
    {
      label: "Restricted Items",
      key: "centralizedRestrictedItems",
      children: <CentralizedRestrictedItems />,
    },
  ];

  const handleLagsRestrict = (subActiveTab: any) => {
    if (subActiveTab === "centralizedLagsLiquidItemImage") {
      return (
        <Button
          onClick={() => {
            navigate(
              "/centralized/centralizedLagsAndRestrictedItems/centralizedLags/centralizedLagsLiquidItemImage/add"
            );
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Liquid Item Image
        </Button>
      );
    }
    if (subActiveTab === "centralizedLagsSteps") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedLagsAndRestrictedItems/centralizedLags/centralizedLagsSteps/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Lags Steps
        </Button>
      );
    }
    if (subActiveTab === "centralizedLagsGuidelinesContent") {
      return (
        <Button
          onClick={() => {
            navigate(
              "/centralized/centralizedLagsAndRestrictedItems/centralizedLags/centralizedLagsGuidelinesContent/add"
            );
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Guidelines Content
        </Button>
      );
    }
    if (subActiveTab === "centralizedRestrictedItemsCheckedInCabinRestrictionsImage") {
      return (
        <Button
          onClick={() => {
            navigate(
              `/centralized/centralizedLagsAndRestrictedItems/centralizedRestrictedItems/add?type=${subActiveTab}`
            );
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Checked-In & Cabin Restrictions Image
        </Button>
      );
    }

    if (subActiveTab === "centralizedRestrictedItemsCabinOnlyRestrictionsImage") {
      return (
        <Button
          onClick={() => {
            navigate(
              `/centralized/centralizedLagsAndRestrictedItems/centralizedRestrictedItems/add?type=${subActiveTab}`
            );
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Cabin-Only Restrictions Image
        </Button>
      );
    }
  };

  return (
    <ContentWrapper
      title={"Lags & Restricted Items"}
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleLagsRestrict(query.get("subActiveTab"))}
      airportText={`Eraman and Passenger`}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={travellersInfoCard}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
